/** Cauce — el cauce de un río: dos riberas y la corriente que las atraviesa. */
export const CauceMark = ({ reverse, ...props }) => (
  <svg viewBox="0 0 32 32" fill="none" aria-hidden="true" {...props}>
    <path
      d="M7 4c0 7 4 9 4 12s-4 5-4 12"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <path
      d="M25 4c0 7-4 9-4 12s4 5 4 12"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <path
      d="M16 7v18"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      opacity="0.45"
    />
  </svg>
);

/** Llum — luz: un rombo de luz con su destello. Guiño a Torre Llum. */
export const LlumMark = ({ reverse, ...props }) => (
  <svg viewBox="0 0 32 32" fill="none" aria-hidden="true" {...props}>
    <path
      d="M16 3.5 22 16l-6 12.5L10 16 16 3.5Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path d="M16 11.5 18.6 16 16 20.5 13.4 16 16 11.5Z" fill="currentColor" />
    <path
      d="M3.5 16h4M24.5 16h4"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      opacity="0.5"
    />
  </svg>
);

/** Cima — la cumbre: dos crestas y el punto más alto marcado aparte. */
export const CimaMark = ({ reverse, ...props }) => (
  <svg viewBox="0 0 32 32" fill="none" aria-hidden="true" {...props}>
    <path
      d="M2.5 25 12 8l5.5 9.8"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.5 25 21 11.5 29.5 25H13.5Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path d="M21 11.5 24.8 18h-7.6L21 11.5Z" fill="currentColor" />
  </svg>
);

/** Norte — la brújula: rosa de los vientos con la aguja al norte. */
export const NorteMark = ({ reverse, ...props }) => (
  <svg viewBox="0 0 32 32" fill="none" aria-hidden="true" {...props}>
    <circle cx="16" cy="16" r="12.5" stroke="currentColor" strokeWidth="1.6" />
    <path d="M16 8.5 19 16l-3 7.5-3-7.5 3-7.5Z" fill="currentColor" />
    <path d="M13 16h6" stroke="currentColor" strokeWidth="1.6" opacity="0.35" />
    <path
      d="M16 1.5v2.5M16 28v2.5M1.5 16H4M28 16h2.5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      opacity="0.55"
    />
  </svg>
);
/* ---------------------------------------------------------------------------
   Nombres en inglés / nórdico. Mismo trazo de 1.6 y mismo lienzo de 32,
   para que convivan con los de arriba como un solo sistema.
   --------------------------------------------------------------------------- */

/** Nord — la estrella polar: el punto fijo del cielo del norte. */
export const NordMark = ({ reverse, ...props }) => (
  <svg viewBox="0 0 32 32" fill="none" aria-hidden="true" {...props}>
    <path
      d="M16 2.5 18.7 13.3 29.5 16 18.7 18.7 16 29.5 13.3 18.7 2.5 16 13.3 13.3 16 2.5Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path d="M16 8.5 17.6 14.4 23.5 16 17.6 17.6 16 23.5 14.4 17.6 8.5 16 14.4 14.4 16 8.5Z" fill="currentColor" opacity="0.9" />
  </svg>
);

/** Arrow — la flecha: una sola dirección, sin desviarse. */
export const ArrowMark = ({ reverse, ...props }) => (
  <svg viewBox="0 0 32 32" fill="none" aria-hidden="true" {...props}>
    <path d="M16 28.5V6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <path d="M16 3.5 22.5 13h-13L16 3.5Z" fill="currentColor" />
    <path
      d="M10.5 21.5 16 26l5.5-4.5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity="0.45"
    />
  </svg>
);

/** Beacon — la señal encendida: el fuego que se ve desde lejos. */
export const BeaconMark = ({ reverse, ...props }) => (
  <svg viewBox="0 0 32 32" fill="none" aria-hidden="true" {...props}>
    <circle cx="16" cy="12" r="4" fill="currentColor" />
    <path
      d="M16 2v3.5M16 18.5V22M6 12H2.5M29.5 12H26M8.9 4.9 6.5 2.5M23.1 4.9l2.4-2.4"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      opacity="0.55"
    />
    <path
      d="M11.5 28 14 20.5M20.5 28 18 20.5M7.5 28h17"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Keel — la quilla: la pieza bajo el agua que impide que el barco vuelque. */
export const KeelMark = ({ reverse, ...props }) => (
  <svg viewBox="0 0 32 32" fill="none" aria-hidden="true" {...props}>
    <path
      d="M3.5 11h25l-3.2 7.5c-.5 1.2-1.7 2-3 2H9.7c-1.3 0-2.5-.8-3-2L3.5 11Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path d="M14.4 20.5h3.2V29h-3.2v-8.5Z" fill="currentColor" />
    <path
      d="M2 15.5h3M27 15.5h3"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      opacity="0.45"
    />
    <path d="M16 3.5V11" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" opacity="0.55" />
  </svg>
);

/** Meridian — la línea que parte el globo: una referencia que no se mueve. */
export const MeridianMark = ({ reverse, ...props }) => (
  <svg viewBox="0 0 32 32" fill="none" aria-hidden="true" {...props}>
    <circle cx="16" cy="16" r="12.5" stroke="currentColor" strokeWidth="1.6" />
    <path d="M16 3.5v25" stroke="currentColor" strokeWidth="1.6" />
    <ellipse cx="16" cy="16" rx="5.6" ry="12.5" stroke="currentColor" strokeWidth="1.6" opacity="0.5" />
    <path d="M3.5 16h25" stroke="currentColor" strokeWidth="1.6" opacity="0.35" />
  </svg>
);

/** Helm — el timón: quien lleva el rumbo del asunto. */
export const HelmMark = ({ reverse, ...props }) => (
  <svg viewBox="0 0 32 32" fill="none" aria-hidden="true" {...props}>
    <circle cx="16" cy="16" r="8.5" stroke="currentColor" strokeWidth="1.6" />
    <circle cx="16" cy="16" r="2.6" fill="currentColor" />
    <path
      d="M16 2.5v5M16 24.5v5M2.5 16h5M24.5 16h5M6.4 6.4l3.5 3.5M22.1 22.1l3.5 3.5M25.6 6.4l-3.5 3.5M9.9 22.1l-3.5 3.5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

/** Vantage — el mirador: desde arriba se ve más lejos que desde el llano. */
export const VantageMark = ({ reverse, ...props }) => (
  <svg viewBox="0 0 32 32" fill="none" aria-hidden="true" {...props}>
    <path d="M3 27h26" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <path d="M4 27V17.5h7.5V27" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <circle cx="7.75" cy="13" r="2.6" fill="currentColor" />
    <path
      d="M11.5 10.5 29 4.5M11.5 15.5 29 21.5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      opacity="0.55"
    />
  </svg>
);

/** Crest — la cresta que rompe: el punto más alto de la ola. */
export const CrestMark = ({ reverse, ...props }) => (
  <svg viewBox="0 0 32 32" fill="none" aria-hidden="true" {...props}>
    <path
      d="M2.5 21C2.5 21 6 20.5 8.5 16.5 11 12.5 13 5.5 19 5.5c5 0 8 4 8 8.5 0 3.4-2.4 5.5-5 5.5-2.3 0-4-1.6-4-3.6"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M19 12.5a3.4 3.4 0 1 1 0 6.8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <path
      d="M3 26h9M15.5 26h13.5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      opacity="0.45"
    />
  </svg>
);
